<!-- Modal LOGIN-->
<div class="modal fade contenedor-modal" id="modalLogin" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body p-0">
                <app-login-form [esModal]="true" (resultEvent)="onLogin($event)"
                    (goRegister)="abrirModal(modalRegister)">
                </app-login-form>
            </div>
        </div>
    </div>
</div>

<!-- Modal REGISTRO-->
<div class="modal fade contenedor-modal" id="modalRegister" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body p-0">
                <app-register-form [esModal]="true" (resultEvent)="onRegister($event)"
                    (goLogin)="abrirModal(modalLogin)">
                </app-register-form>
            </div>
        </div>
    </div>
</div>

<!-- Modal TARJETAS-->
<div class="modal fade contenedor-modal" id="modalPayment" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" *ngIf="objetoPurchase">
            <div class="modal-body p-0">
                <app-payment-options [info]="infoCompra" [typeTransaction]="objetoPurchase.type"
                    [objetoPurchase]="objetoPurchase" [ppv]="false"></app-payment-options>
            </div>
        </div>
    </div>
</div>

<!-- Modal CONDICIONES-->
<div class="modal fade contenedor-modal" id="modalConditions" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body p-0">
                <!-- <app-payment-options
          [typeTransaction]="objetoPurchase.type"
          [objetoPurchase]="objetoPurchase"
        ></app-payment-options> -->

                <app-conditions (onClose)="onCondiciones($event)"></app-conditions>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12 mt-5">
        <div class="row">
            <div class="col-12">
                <div class="AFO_Container text-white mb-4">

                    <!-- SLIDER -->
                    <div class="felixSlider">
                        <section>
                            <h1>Una sala de<br> Cinemateca<br> en <span>tu casa</span></h1>
                        </section>
                    </div>

                    <!-- CONTENIDO ILIMITADO -->
                    <div class="felixContenidoIlimitado">
                        <h2> Mirá contenidos ilimitados</h2>
                        <p>Largometrajes, cortometrajes, materiales de archivo, series y conferencias.</p>
                    </div>

                    <!-- LOADING -->
                    <div class="card-body text-center" *ngIf="loading">
                        <div class="spinner-border mt-2 text-secondary spinner-color"
                            style="width: 1.5rem; height: 1.5rem" role="status" *ngIf="loading">
                            <span class="sr-only">Cargando...</span>
                        </div>
                    </div>

                    <div *ngIf="!loading">
                        <div class="felixGridPlanesIlimitados">
                            <section class="felixPlanes">
                                <section class="felixTittle">
                                    <h2>Plan Mensual</h2>
                                    <img src="../../../assets/img/logos_cinemateca/Logo completo negro.png"
                                        alt="Logo Cinemateca">
                                </section>
                                <hr>
                                <p>Contenido ilimitado a +Cinemateca<br>y a <span style="color: #FF0066;">Félix
                                        Oliver.</span></p>
                                <section class="felixPrecio">
                                    <label>${{plans[0].price}} <span>/mes *</span></label>
                                    <a class="felixBotonesPrecio" id="mensualMasCinemateca" href="#"
                                        (click)="clickSub($event, 3)">ELEGÍ
                                        MENSUAL</a>
                                </section>
                                <hr>
                                <p class="felixLegalPrecio">*El pago se hace a través de tarjeta de crédito VISA, OCA,
                                    Cabal, Creditel o
                                    Créditos Directos. No está incluida en esta modalidad la tarjeta Mastercard. La
                                    suscripción tiene un mínimo
                                    de 3 meses. </p>
                            </section>

                            <section class="felixPlanes">
                                <section class="felixTittle">
                                    <h2>Plan Anual</h2>
                                    <img src="../../../assets/img/logos_cinemateca/Logo completo negro.png"
                                        alt="Logo Cinemateca">
                                </section>
                                <hr>
                                <p>Contenido ilimitado a +Cinemateca<br>y a <span style="color: #FF0066;">Félix
                                        Oliver.</span></p>
                                <section class="felixPrecio">
                                    <label>${{plans[0].anualprice}} <span>/pago único *</span></label>
                                    <a class="felixBotonesPrecio" id="anuallMasCinemateca" href="#"
                                        (click)="clickSub($event, 4)">ELEGÍ ANUAL</a>
                                </section>
                                <hr>
                                <p class="felixLegalPrecio">*El pago se hace a través de tarjeta de crédito VISA, OCA,
                                    Cabal, Creditel o
                                    Créditos Directos. No está incluida en esta modalidad la tarjeta Mastercard.</p>
                            </section>
                        </div>

                        <!-- BANNER FELIX -->
                        <div class="felixBanner">
                            <section class="felixSectionL">
                                <h2>Disfrutá y apoyá el cine uruguayo.</h2>
                                <p>Uruguay tuvo su propio Georges Mélies y se llamó Félix Oliver, el pionero del cine
                                    uruguayo. Ahora en la
                                    plataforma que lleva su nombre podés contratar el <span
                                        style="color: #FF0066; font-weight: 500;">Plan Félix
                                        Oliver.</span>
                                    Encontrá cine uruguayo, el viejo y el nuevo, largos, cortos y mediometrajes,
                                    documentales y ficciones,
                                    series, entrevistas, fragmentos de material de archivo, posters, reseñas e
                                    información
                                    sobre equipos de
                                    trabajo.
                                </p>
                                <a class="felixBotones" href="/felix-oliver">VER MÁS</a>
                            </section>
                            <section class="felixSectionR">
                                <h2><span>Felix Oliver</span>,<br>pionero del cine uruguayo</h2>
                            </section>
                        </div>

                        <!-- PLANES -->
                        <div class="felixGridPlanesLimitados">
                            <section class="felixPlanes">
                                <h2>Plan Mensual <span style="color:#FF0066; font-weight:700;">Félix Oliver</span></h2>
                                <hr>
                                <p>Acceso ilimitado a películas del catálogo y un costo adicional bonificado de $90 para
                                    ver
                                    los estrenos.</p>
                                <section class="felixPrecio">
                                    <label>${{plans[1].price}} <span>/mes *</span></label>
                                    <a class="felixBotonesPrecio" id="mensualFelixOliver" href="#"
                                        (click)="clickSub($event, 1)">ELEGÍ
                                        MENSUAL</a>
                                </section>
                                <hr>
                                <p class="felixLegalPrecio">*El pago se hace a través de tarjeta de crédito VISA, OCA,
                                    Cabal, Creditel o
                                    Créditos Directos. No está incluida en esta modalidad la tarjeta Mastercard. La
                                    suscripción tiene un mínimo
                                    de 3 meses.</p>
                            </section>

                            <section class="felixPlanes">
                                <h2>Plan Anual <span style="color:#FF0066; font-weight:700;">Félix Oliver</span></h2>
                                <hr>
                                <p>Acceso ilimitado a películas del catálogo y un costo adicional bonificado de $90 para
                                    ver
                                    los estrenos.</p>
                                <section class="felixPrecio">
                                    <label>${{plans[1].anualprice}} <span>/pago único *</span></label>
                                    <a class="felixBotonesPrecio" id="anualFelixOliver" href="#"
                                        (click)="clickSub($event, 2)">ELEGÍ ANUAL</a>
                                </section>
                                <hr>
                                <p class="felixLegalPrecio">*El pago se hace a través de tarjeta de crédito VISA, OCA,
                                    Cabal, Creditel o
                                    Créditos Directos. No está incluida en esta modalidad la tarjeta Mastercard</p>
                            </section>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>